import React from 'react';

import { getIsLoggedIn, isVerificationAccount } from '@app/redux/auth/auth.selectors';
import { useAppSelector } from '@app/redux/hooks';

import { AnimatedRedirect } from '@components/transition/route';

import RoutePaths from '../paths';
import useGenerateRoutePath from '../paths/useGenerateRoutePath';

const OnlyVerifiedAccountRoute = ({ children }: { children: JSX.Element }) => {
	const isLoggedIn = useAppSelector(getIsLoggedIn);
	const { needVerifyAccount, needMFASetup } = useAppSelector(isVerificationAccount);
	const generateRoutePath = useGenerateRoutePath();

	if (!isLoggedIn) return <AnimatedRedirect to={generateRoutePath(RoutePaths.AUTH.LOGIN)} />;
	else if (needVerifyAccount || needMFASetup) return children;
	else return <AnimatedRedirect to={generateRoutePath(RoutePaths.MAIN.APPLICATIONS)} />;
};

export default OnlyVerifiedAccountRoute;
